/**
 * Translations for core  terms.
 *
 * @package translations
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ITranslationManager } from "@adapptio/lib-core";

import editor_en_US from "../translations/editor/editor_en_US.json";
import editor_cs_CZ from "../translations/editor/editor_cs_CZ.json";

/**
 * Registers Editor translations
 *
 * @param translationManager Translation Manager Instance
 */
export function registerEditorTranslations(translationManager: ITranslationManager) {
	translationManager.registerTranslations("editor", "en_US", editor_en_US, "translations");
	translationManager.registerTranslations("editor", "cs_CZ", editor_cs_CZ, "translations");
}
